import React from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import BarChart from './BarChart/index';
import { languagesChartItems } from '../domain/languagesChart';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartLi: {
      height: '30px',
      marginBottom: '10px',
      background: 'linear-gradient(to left, #005FFF, #66FFFF)',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
      opacity: 0,
      animation: '1s anim-lightspeed-in ease forwards',
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
      }
    },
    chartUl: {
      listStyle: "none",
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
      }
    },
  }),
);



const LanguagesChart: React.FC = () => {
  return (
     <React.Fragment>
      <BarChart
       barChartItem={languagesChartItems}
       classes={useStyles}
      />
     </React.Fragment>
  );
}

export default LanguagesChart;
